import React from "react";
import { Helmet } from "react-helmet-async";
import { SiteHeader } from "../components/layout/SiteHeader";
import { SiteFooter } from "../components/layout/SiteFooter";
import { Container } from "../components/layout/Container";

export function SolutionsPage() {
  return (
    <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden bg-background-dark text-white">
      <Helmet>
        <title>Solutions — Container Load Optimisation for Logistics Teams | Feuteuristix</title>
        <meta name="description" content="Container planning solutions for freight forwarders, 3PLs, FMCG exporters, and TMS platforms. Reduce freight costs and eliminate container underutilisation." />
        <meta property="og:title" content="Solutions — Container Load Optimisation for Logistics Teams | Feuteuristix" />
        <meta property="og:description" content="Container planning solutions for freight forwarders, 3PLs, FMCG exporters, and TMS platforms. Reduce freight costs and eliminate container underutilisation." />
        <meta property="og:url" content="https://feuteuristix.com/solutions" />
        <meta name="twitter:title" content="Solutions — Container Load Optimisation for Logistics Teams | Feuteuristix" />
        <meta name="twitter:description" content="Container planning solutions for freight forwarders, 3PLs, FMCG exporters, and TMS platforms. Reduce freight costs and eliminate container underutilisation." />
        <link rel="canonical" href="https://feuteuristix.com/solutions" />
      </Helmet>
      <SiteHeader />
      <main className="flex-1 pt-28 pb-16">
        <Container>
          <section className="rounded-2xl border border-white/10 bg-white/5 p-8 md:p-12">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">Solutions</p>
            <h1 className="mt-4 text-4xl font-black leading-tight md:text-5xl">
              End-to-end load planning built for modern logistics teams.
            </h1>
            <p className="mt-5 max-w-3xl text-slate-300">
              Feuteuristix helps 3PLs, shipping lines, and warehouse operators optimize every shipment with better space utilization,
              lower freight cost, and faster dispatch execution.
            </p>

            <div className="mt-8 grid gap-4 md:grid-cols-3">
              <div className="rounded-xl border border-white/10 bg-black/20 p-5">
                <h3 className="font-bold text-white">Capacity Optimization</h3>
                <p className="mt-2 text-sm text-slate-300">Smart load building to maximize truck and container fill rates.</p>
              </div>
              <div className="rounded-xl border border-white/10 bg-black/20 p-5">
                <h3 className="font-bold text-white">Shipment Orchestration</h3>
                <p className="mt-2 text-sm text-slate-300">Coordinate warehouse, dispatch, and carrier execution from one platform.</p>
              </div>
              <div className="rounded-xl border border-white/10 bg-black/20 p-5">
                <h3 className="font-bold text-white">Decision Visibility</h3>
                <p className="mt-2 text-sm text-slate-300">Track capacity, route trade-offs, and performance metrics in real time.</p>
              </div>
            </div>
          </section>
        </Container>
      </main>
      <SiteFooter />
    </div>
  );
}
